
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import TeacherDashboard from "./pages/TeacherDashboard";
import TeacherRegister from "./pages/TeacherRegister";
import StudentDashboard from "./pages/StudentDashboard";
import StudentManagement from "./pages/StudentManagement";
import ClassManagement from "./pages/ClassManagement";
import AttendanceOverview from "./pages/AttendanceOverview";
import AttendancePage from "./pages/AttendancePage";
import FeesCollection from "./pages/FeesCollection";
import TeacherProfile from "./pages/TeacherProfile";
import StudentAttendance from "./pages/StudentAttendance";
import StudentFees from "./pages/StudentFees";
import StudentProfile from "./pages/StudentProfile";
import AdminDashboard from "./pages/AdminDashboard";
import AdminStudents from "./pages/AdminStudents";
import AdminTeachers from "./pages/AdminTeachers";
import AdminClasses from "./pages/AdminClasses";
import AdminAttendance from "./pages/AdminAttendance";
import AdminFees from "./pages/AdminFees";
import AdminSettings from "./pages/AdminSettings";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/teacher/register" element={<TeacherRegister />} />
          <Route path="/teacher/login" element={<Login />} />
          <Route path="/teacher/dashboard" element={<TeacherDashboard />} />
          <Route path="/teacher/students" element={<StudentManagement />} />
          <Route path="/teacher/classes" element={<ClassManagement />} />
          <Route path="/teacher/attendance" element={<AttendanceOverview />} />
          <Route path="/teacher/attendance/:classId" element={<AttendancePage />} />
          <Route path="/teacher/fees" element={<FeesCollection />} />
          <Route path="/teacher/profile" element={<TeacherProfile />} />
          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route path="/student/attendance" element={<StudentAttendance />} />
          <Route path="/student/fees" element={<StudentFees />} />
          <Route path="/student/profile" element={<StudentProfile />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/students" element={<AdminStudents />} />
          <Route path="/admin/teachers" element={<AdminTeachers />} />
          <Route path="/admin/classes" element={<AdminClasses />} />
          <Route path="/admin/attendance" element={<AdminAttendance />} />
          <Route path="/admin/fees" element={<AdminFees />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
